// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2b53V","fileBtn":"File_fileBtn__I2y2u","closeBtn":"File_closeBtn__EqL3o","fileSelected":"File_fileSelected__-UGeO","disabled":"File_disabled__RhTv1"};